var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('BlackBox'),_c('BGuide'),_c('WhiteBox'),_c('Evaluation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }